import { useMutation } from "react-query";
import { addLeasedEquipment } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

const useAddLeasedEquipment = () => {
  return useMutation(addLeasedEquipment);
};
export default useAddLeasedEquipment;
